'use client';

import {
  useIsWalletMatch,
  WalletInput,
} from '#/components/ethereum/wallet-input';
import { Button } from '#/components/ui/button';
import {
  DialogClose,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '#/components/ui/dialog';
import { Label } from '#/components/ui/label';
import {
  TransactionDetails,
  TransactionViewOnButton,
} from '#/modules/display/transaction';
import { ValidatorRow } from '#/modules/display/validator-row';
import { useActor } from '@xstate/react';
import { Translation } from 'intl-lib';
import { Loader2 } from 'lucide-react';
import { useContext } from 'react';
import { MachineContext } from './contexts/machine';

export function Information() {
  const interpreter = useContext(MachineContext);
  const [state, dispatch] = useActor(interpreter);
  const target = state.context.target!;
  const transactionHash = state.context.transactionHash!;

  const isWalletMatch = useIsWalletMatch(target.withdrawaddr);

  return (
    <>
      <DialogHeader>
        <DialogTitle>
          <Translation path="my_staking.upgrade_dialog.title" />
        </DialogTitle>
        <DialogDescription>
          <Translation path="my_staking.upgrade_dialog.description" />
        </DialogDescription>
      </DialogHeader>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <Label>
            <Translation path="EthereumStaking.WithdrawalAddress" />
          </Label>
          <div>
            <WalletInput address={target.withdrawaddr} />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <Label>
            <Translation path="my_staking.upgrade_dialog.selected_validator" />
          </Label>
          <div>
            <ValidatorRow item={target} />
          </div>
        </div>
        {state.hasTag('completed') && (
          <div className="flex flex-col gap-2">
            <Label>Transaction</Label>
            <div>
              <TransactionDetails transactionHash={transactionHash} />
            </div>
          </div>
        )}
      </div>
      <DialogFooter>
        <DialogClose asChild>
          <Button variant="secondary" type="button">
            <Translation path="Application.Dialog.CancelButtonLabel" />
          </Button>
        </DialogClose>
        {state.hasTag('completed') ? (
          <TransactionViewOnButton transactionHash={transactionHash} />
        ) : (
          <Button
            type="button"
            variant="primary"
            disabled={!isWalletMatch || state.hasTag('loading')}
            onClick={() => {
              dispatch('NEXT');
            }}
          >
            {state.hasTag('loading') && <Loader2 className="animate-spin" />}
            <Translation path="my_staking.upgrade_dialog.trigger" />
          </Button>
        )}
      </DialogFooter>
    </>
  );
}
